<template>
  <div class="quadro" v-if="firstFetchDone && panelWidth">
    <div class="header">
      <div class="row">
        <div class="party col-xs-6">
          <div class="party-status-left">
            <strong>{{ negoDetails.second_party_short_name }}</strong>
          </div>
        </div>
        <div class="party col-xs-6 text-right">
          <div class="party-status-right">
            <strong>{{ negoDetails.first_party_short_name }}</strong>
          </div>
        </div>
      </div>
    </div>

    <slider
      v-for="issue in issueDetailList"
      :ref="'slider' + issue.issue_id"
      :key="'slider' + issue.issue_id"

      :width="panelWidth"
      :issue-details="issue"
      :agreement-reached="agreementReached && issue.agreement_value"
      :freeze="true"
    ></slider>

    <s-footer>
      <template #notification>
        <span class="error-msg">
          {{ store.state.errorMessage }}
        </span>
        <span v-if="store.state.offline" class="offline-msg">
          <b>Not connected.</b> Trying to reconnect with server...
        </span>
      </template>
    </s-footer>
  </div>
</template>

<script>
  import Slider from 'slider'
  import SFooter from 'components/footer'
  import getStore from "store/index"

  export default {
    name: 'quadro_nonparty', // or quadro_m for mediated (or facilitated)
    props: ['apiEndpoint', 'caseId', 'credentials'],
    data() {
      return {
        store: getStore(),
        panelWidth: 0, // 1140
        firstFetchDone: false,
      }
    },
    components: {
      Slider, SFooter,
    },
    computed: {
      issueDetailList() {
        return this.negoDetails.issues
      },
      negoDetails() {
        return this.store.state.negoDetails
      },
      agreementReached() {
         let tmp = ['agreement', 'automated_agreement', 'end_agreement'].includes(this.negoDetails.status)
         let ele = document.getElementById('negotiation-payment-success-alert')
         let agreeEle = document.getElementById('negotiation-agreement-alert')
         if (tmp && ele && ele.classList.contains('hidden')){
           window.location.reload()
         } else if(tmp && agreeEle && agreeEle.classlist.contains('hidden')){
           agreeEle.classList.remove('hidden')
         }
         return tmp
      }
    },
    methods: {
      setApiEndpoint() {
        this.store.setEndpoint(this.apiEndpoint, this.credentials)
      },
      setPanelWidth() {
        let parent = this.$el.parentNode
        this.panelWidth = parent.offsetWidth - 2*15  // width - 2*margin
      },
      async fetchData() {
        // Fetch the data from the backend
        await this.store.fetchData(this.caseId, true)
      },
      async fetchDataOnce() {
        await this.fetchData()
        this.firstFetchDone = true
      },
      sleep: (ms) => new Promise(resolve => setTimeout(resolve, ms))
    },
    created() {
      this.setApiEndpoint()
      this.fetchDataOnce()
    },
    mounted() {
      this.setPanelWidth()
    }
  }
</script>

<style scoped>
  .error-msg {
    color: #ff3939;
  }
  .offline-msg {
    color: orange;
  }
  .party-status-left {
    padding-left: 30px;
  }
  .party-status-right {
    padding-right: 30px;
  }
</style>

